// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__ZG8Fy","noLongPress":"navy-modal_noLongPress__+h71n"};